import { Pizza } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function EmptyState({ title, message, action = null, icon: Icon = Pizza }) {
  const { t } = useTranslation();
  return (
    <div
      data-testid="empty-state"
      className="flex flex-col items-center justify-center py-16 px-6 text-center gap-3 bg-white rounded-2xl border border-slate-200"
    >
      <div className="w-14 h-14 rounded-full bg-[#FFFBE6] flex items-center justify-center">
        <Icon className="w-7 h-7 text-[#FFDF00]" strokeWidth={2} />
      </div>
      <h3 className="text-lg font-bold text-[#1A1A1A] font-display">{title || t("empty.defaultTitle")}</h3>
      <p className="text-sm text-slate-500 max-w-sm">{message || t("empty.defaultMessage")}</p>
      {action}
    </div>
  );
}
